import React, { Component } from 'react'
import SimpleReactValidator from "simple-react-validator";
import ContentWrapper from "../../../components/common/ContentWrapper";
import CardHeader from "../../../components/common/CardHeader";
import CardBody from "../../../components/common/CardBody";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  sweetConfirmAlert,
  sweetErrorAlert,
  sweetStatusAlert,
  sweetSuccessAlert,
} from "../../../components/common/SweetAlert";
import Spinner from "react-bootstrap/Spinner";

import { history } from "../../../helper/history";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Chip,
  Tooltip,
  Box,
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ListSubheader from "@mui/material/ListSubheader";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";
import DatePicker from "react-datepicker";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { TeachersPaymentService } from '../../../service/manage/teacher_payment_service/manage.teacher_payment.service.js';
import { Payment, RecordVoiceOver, RecordVoiceOverSharp } from "@mui/icons-material";
import TimeZoneHandler from '../../../handlers/TimeZoneHandler.js';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HelpIcon from '@mui/icons-material/Help';
import debounce from "lodash.debounce";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import './ManageTeacherPayment.css';
import CloseIcon from '@mui/icons-material/Close';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

const privilegeSetup = (
  <div>
    <div className='Ttip'>Privilege: View + Add  + No Owner Restriction (Administration)</div>
    <ul>
      <li>Add Teachers</li>
      <li>Approve or Reject Teacher Hour Captures</li>
      <li>Delete Teacher Hour Captures and Payments</li>
    </ul>
    <div className='Ttip'>Privilege: View + Edit  + No Owner Restriction (Administration)</div>
    <ul>
      <li>Add Teacher Payment</li>
      <li>Approve or Reject Teacher Hour Captures</li>
      <li>Delete Teacher Hour Captures and Payments</li>
    </ul>
    <div className='Ttip'>Privilege: View + Edit + Add + Delete + No Owner Restriction (Administration)</div>
    <ul>
      <li>Add Teachers</li>
      <li>Add Teacher Payment</li>
      <li>Approve or Reject Teacher Hour Captures</li>
      <li>Delete Teacher Hour Captures and Payments</li>
    </ul>
    <div className='Ttip'>Privilege: Add with Owner Restriction (Teacher)</div>
    <ul>
      <li>Add Hour Capture Record</li>
      <li>View Hour Capture Records</li>
      <li>View Payment Records</li>
    </ul>
  </div>
);

export default class ManageTeacherPament extends Component {

    constructor(props) {
        super(props);

        this.state = {
          mid: this.props.state ? this.props.state.mid : null,
          lg_user_id: this.props.state.lg_user_id || null,
          lg_user_table_id: this.props.state.lg_user_table_id || null,
          owner_restriction: this.props.state.owner_restriction || null,
          user_list_restriction: this.props.state.user_list_restriction || null,
          form_list_id:this.props.state.form_list_id || null,
          form_display_title: this.props.state
            ? this.props.state.form_display_title
            : null,
          privilege_view: this.props.state ? this.props.state.privilege_view : null,
          privilege_add: this.props.state ? this.props.state.privilege_add : null,
          privilege_edit: this.props.state ? this.props.state.privilege_edit : null,
          privilege_delete: this.props.state ? this.props.state.privilege_delete : null,
          breadcrumb: this.props.state ? this.props.state.breadcrumb : null,
          hour_capture_view:false,
          payment_capture_view:false,
          showAddModal:false,
          showUpdateModal:false,
          flg_list_active:null,
          teachers_list:[],
          selected_teacher:null,
          selected_teacher_update:null,
          teachers:[],
          teachers_count:0,
          teacher_hours:[],
          teacher_hours_count:0,
          teacher_payments:[],
          teacher_payments_count:0,
          showHourAddModal:false,
          showPaymentAddModal:false,
          isTeacherListLoading:false,
          dropdown_loading:false,

          // main table
          currentPage: 0,
          limit: 10,
          offset: 0, 
          sort_column:'user_code',
          sort_direction:'desc',
          search_term:' ',
          searchError:false,

          // hours table
          hours_currentPage: 0,
          hours_limit: 10,
          hours_offset: 0, 
          hours_sort_column:'date',
          hours_sort_direction:'desc',

          // payments table
          payment_currentPage: 0,
          payment_hours_limit: 10,
          payment_hours_offset: 0, 
          payment_hours_sort_column:'date',
          payment_hours_sort_direction:'desc',

          hour_description:'',
          hour_date:null,
          work_hours:0.0,
          isModifiedHour:false,

          payment_description:'',
          payment_date: null,
          payment_amount:0.0,
          isModifiedPayment:false,

          fixed_amount:0.0,
          hourly_rate:0.0,
          note:'',

          addTeacherLoading:false,
          isTeacherHourListLoading:false,
          selected_teacher_id:null,
          isAddTeachersHourRecordLoading:false,

          isTeacherPaymentListLoading:false,
          isAddTeachersPaymentLoading:false,

          updateTeacherLoading:false,
          update_note:'',

          hasError: false
        };
        this.createValidationsInstance();
        this.debouncedHandleSearch = debounce(this.getTeachers, 1000);
      }

      static getDerivedStateFromError(error) {
        return { hasError: true };
      }

      createValidationsInstance() {
        this.validator = new SimpleReactValidator({
            validators: {
                positiveOrEmpty: {
                    message: 'The :attribute must be a positive number or zero.',
                    rule: (val, params, validator) => {
                        return val === '' || parseFloat(val) >= 0;
                    },
                    messageReplace: (message, params) =>
                      message.replace(":values", this.helpers.toSentence(params || '')), // optional
                    required: true,
                },
                atLeastOneFieldRequired: {
                    message: 'Either Fixed Amount or Hourly Rate must be provided.',
                    rule: (val, params, validator) => {
                      const fixedAmount = parseFloat(this.state.fixed_amount);
                      const hourlyRate = parseFloat(this.state.hourly_rate);
                      return (fixedAmount > 0 || hourlyRate > 0);
                    },
                    
                    messageReplace: (message, params) =>
                      message?.replace(":values", this.helpers?.toSentence(params || '')), // optional
                    required: true,
                },
                greaterThanZero: {
                  message: 'The :attribute must be greater than 0.',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /^\d*\.?\d+$/) && parseFloat(val) > 0;
                  },
                  required: true,
                },
            }
        });
    }
    

      componentDidCatch(error, errorInfo) {
        console.log("ErrorBoundary caught an error", error, errorInfo);
      }

      componentDidMount(){
        
        const { mid,breadcrumb2, nodeTitle, flg_list_active,lg_user_id,lg_user_table_id,owner_restriction,form_list_id,user_list_restriction } = this.props.state;
        this.setState({
          breadcrumb2: breadcrumb2,
          nodeTitle,
          flg_list_active,
          lg_user_id,
          lg_user_table_id,
          owner_restriction,
          mid,
          form_list_id,
          user_list_restriction
        },()=>{
          this.getTeachers()
        });
      }

      getTeachersList = async() =>{

        this.setState({dropdown_loading:true})
        try {

          const {mid,lg_user_id,lg_user_table_id,form_list_id} = this.state

          await TeachersPaymentService.getTeachersList(mid,lg_user_id,lg_user_table_id,form_list_id)
            .then((response)=>{
              if(response.success){
                this.setState({teachers_list: response?.data?.teachers})
              }
              this.setState({dropdown_loading:false})
            })
            .catch(()=>{
              console.log("Error getting teachers list");
              this.setState({dropdown_loading:false})

            })
        } 
        catch (error) {
          console.log("Error getting teachers list");
          this.setState({dropdown_loading:false})
        }

      }

      toggleModal = (showModal) => {

        this.validator.hideMessageFor('hourly_rate')
        this.validator.hideMessageFor('fixed_amount')
        this.validator.hideMessageFor('note')
        this.validator.purgeFields();

        this.setState((prevState) => ({
          fixed_amount:0.0,
          hourly_rate:0.0,
          note:'',
          showAddModal: !prevState.showAddModal,
        }),()=>{
          if(this.state.showAddModal){
            this.getTeachersList()
          }
          else{
            this.setState({selected_teacher:null})
          }
        });
      };

      toggleHourAddModal = (showModal) => {

        this.validator.hideMessageFor('hour_description');
        this.validator.hideMessageFor('hour_date');
        this.validator.hideMessageFor('work_hours');
        this.validator.purgeFields();

        this.setState((prevState) => ({
          work_hours:0.0,
          hour_date:null,
          hour_description:'',
          showHourAddModal: !prevState.showHourAddModal,
        }));
      };

      togglePaymentAddModal = (showModal) => {
        
        this.validator.hideMessageFor('payment_description')
        this.validator.hideMessageFor('payment_date')
        this.validator.hideMessageFor('payment_amount')
        this.validator.purgeFields();

        this.setState((prevState) => ({
          payment_description:'', 
          payment_amount: 0.0,
          payment_date:null,
          showPaymentAddModal: !prevState.showPaymentAddModal,
        }));
      };

      handlePageChange = (event, newPage) => {
        const { limit } = this.state;
        const newOffset = newPage * limit;
        this.setState(
          {
            offset: newOffset,
            isTeacherListLoading: true,
            currentPage: newPage,
          },
          () => {
            this.getTeachers();
          }
        );
      };
    
      handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
          {
            offset: newOffset,
            isTeacherListLoading: true,
            currentPage: newPage,
          },
          () => {
            this.getTeachers();
          }
        );
      };
    
      handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.offset / newLimit);
        this.setState(
          {
            limit: newLimit,
            offset: newLimit * newPage,
            isTeacherListLoading: true,
            currentPage: newPage,
          },
          () => {
            this.getTeachers();
          }
        );
      };

      hour_handlePageChange = (event, newPage) => {
        const { hours_limit } = this.state;
        const newOffset = newPage * hours_limit;
        this.setState(
          {
            hours_offset: newOffset,
            isTeacherHourListLoading: true,
            hours_currentPage: newPage,
          },
          () => {
            this.getHourCaptureById(this.state.selected_teacher_id);
          }
        );
      };
    
      hour_handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
          {
            hours_offset: newOffset,
            isTeacherHourListLoading: true,
            hours_currentPage: newPage,
          },
          () => {
            this.getHourCaptureById(this.state.selected_teacher_id);
          }
        );
      };
    
      // handle the data fetching as per the data per page limit gets changes
      hour_handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.hours_offset / newLimit);
        this.setState(
          {
            hours_limit: newLimit,
            hours_offset: newLimit * newPage,
            isTeacherHourListLoading: true,
            hours_currentPage: newPage,
          },
          () => {
            this.getHourCaptureById(this.state.selected_teacher_id);
          }
        );
      };

      payment_handlePageChange = (event, newPage) => {
        const { payment_hours_limit } = this.state;
        const newOffset = newPage * payment_hours_limit;
        this.setState(
          {
            payment_hours_offset: newOffset,
            isTeacherPaymentListLoading: true,
            payment_currentPage: newPage,
          },
          () => {
            this.getTeacherPaymentById(this.state.selected_teacher_id);
          }
        );
      };
    
      payment_handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
          {
            payment_hours_offset: newOffset,
            isTeacherPaymentListLoading: true,
            payment_currentPage: newPage,
          },
          () => {
            this.getTeacherPaymentById(this.state.selected_teacher_id);
          }
        );
      };

      // handle the data fetching as per the data per page limit gets changes
      payment_handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.payment_hours_offset / newLimit);
        this.setState(
          {
            payment_hours_limit: newLimit,
            payment_hours_offset: newLimit * newPage,
            isTeacherPaymentListLoading: true,
            payment_currentPage: newPage,
          },
          () => {
            this.getTeacherPaymentById(this.state.selected_teacher_id);
          }
        );
      };

      getTeachers = async() =>{

        this.setState({isTeacherListLoading:true})
        try {

          const {mid,lg_user_id,lg_user_table_id,owner_restriction,limit,offset,sort_column,sort_direction,user_list_restriction,search_term} = this.state

          await TeachersPaymentService.getAll(parseInt(mid),lg_user_id,lg_user_table_id,user_list_restriction,limit,offset,sort_column,sort_direction,search_term)
            .then((response)=>{
              if(response.success){
                this.setState({teachers: response?.data?.teachers, teachers_count: response?.data?.teachers_count})
              }
              this.setState({isTeacherListLoading:false})
            })
            .catch(()=>{
              console.log("Error getting teachers");
              this.setState({isTeacherListLoading:false})

            })
        } 
        catch (error) {
          console.log("Error getting teachers");
          this.setState({isTeacherListLoading:false})
        }

      };

      handleAddTeacherSubmit = () => {
        if (!this.validator.fieldValid('hourly_rate') || !this.validator.fieldValid('fixed_amount') || !this.validator.fieldValid('note')) {
            this.validator.showMessageFor('hourly_rate')
            this.validator.showMessageFor('fixed_amount')
            this.validator.showMessageFor('note')
            this.forceUpdate()
        }
        else if(!this.state.selected_teacher){
          sweetErrorAlert(
            "Error",
            "Please select teacher",
            "Error"
          );
          return;
        }
        else {
          sweetConfirmAlert().then(async() => {
            this.setState({ addTeacherLoading: true })

            const { mid, lg_user_id, lg_user_table_id } = this.props.state;

            const {selected_teacher,fixed_amount,hourly_rate,note} = this.state
            
    
            const newTeacher = {
              user_id:parseInt(selected_teacher),
              node_mid : parseInt(mid),
              create_user_id : lg_user_id,
              create_user_table_id:lg_user_table_id,
              note:note,
              fixed_amount:parseFloat(fixed_amount?fixed_amount:0.0),
              hourly_rate:parseFloat(hourly_rate?hourly_rate:0.0),
            }
            
    
            await TeachersPaymentService.addTeacher(newTeacher)
              .then((result) => {
              if (result.success) {
                this.setState({ fixed_amount:0.0, hourly_rate: 0.0,selected_teacher:null,note:''});
                this.validator.purgeFields();
                this.validator.hideMessages();
                this.getTeachers();
                sweetSuccessAlert(
                  "Success",
                  "Teacher added successfully",
                  "success"
                );
                this.toggleModal()
              } else {
                sweetErrorAlert("Error", "Failed to add teacher");
              }
              this.setState({ addTeacherLoading: false });
            })
            .catch((error)=>{
              console.log(error);
              
              sweetErrorAlert("Error", "Failed to add teacher");
            });
          });
        }
      };

      handleAddNewHoursRecord = () =>{
        if (!this.validator.fieldValid("hour_description") || !this.validator.fieldValid("hour_date") || !this.validator.fieldValid("work_hours")) {
          this.validator.showMessageFor('hour_description')
          this.validator.showMessageFor('hour_date')
          this.validator.showMessageFor('work_hours')
          this.forceUpdate()
        }
        else {
          sweetConfirmAlert().then(async() => {
            this.setState({ isAddTeachersHourRecordLoading: true })

            const { mid, lg_user_id, lg_user_table_id } = this.props.state;

            const {selected_teacher_id,hour_description,work_hours,hour_date} = this.state
            
    
            const newHourCapture = {
              node_mid: parseInt(mid),
              teacher_payment_id:parseInt(selected_teacher_id),
              description : hour_description,
              hours : parseFloat(work_hours),
              date:hour_date,
              lg_user_id:lg_user_id,
              lg_user_table_id:lg_user_table_id,
            }
            
    
            await TeachersPaymentService.addTeacherHourCapture(newHourCapture)
              .then((result) => {
              if (result.success) {
                this.setState({ hour_description:'', work_hours: 0.0,hour_date:null});
                this.validator.purgeFields();
                this.validator.hideMessages();
                this.getHourCaptureById(selected_teacher_id);
                sweetSuccessAlert(
                  "Success",
                  "Record added successfully",
                  "success"
                );
                this.toggleHourAddModal()
              } else {
                sweetErrorAlert("Error", "Failed to add record");
              }
              this.setState({ isAddTeachersHourRecordLoading: false });
            })
            .catch((error)=>{
              console.log(error);
              this.setState({ isAddTeachersHourRecordLoading: false });
              sweetErrorAlert("Error", "Failed to add record");
            });
          });
        }
      }

      handleAddTeacherNewPayment = () =>{
        if (!this.validator.fieldValid("payment_description") || !this.validator.fieldValid("payment_date") || !this.validator.fieldValid("payment_amount")) {
          this.validator.showMessageFor('payment_description')
          this.validator.showMessageFor('payment_date')
          this.validator.showMessageFor('payment_amount')
          this.forceUpdate()
        } 
        else {
          sweetConfirmAlert().then(async() => {
            this.setState({ isAddTeachersPaymentLoading: true })

            const { mid, lg_user_id, lg_user_table_id } = this.props.state;

            const {selected_teacher_id,payment_description,payment_amount,payment_date} = this.state
            
    
            const newPaymentCapture = {
              node_mid: parseInt(mid),
              teacher_payment_id:parseInt(selected_teacher_id),
              description : payment_description,
              amount : parseFloat(payment_amount),
              date:payment_date,
              create_user_id:lg_user_id,
              create_user_table_id:lg_user_table_id,
            }
            
    
            await TeachersPaymentService.addTeacherPayment(newPaymentCapture)
              .then((result) => {
              if (result.success) {
                this.setState({ payment_description:'', payment_amount: 0.0,payment_date:null});
                this.validator.purgeFields();
                this.validator.hideMessages();
                this.getTeacherPaymentById(selected_teacher_id);
                sweetSuccessAlert(
                  "Success",
                  "Payment added successfully",
                  "success"
                );
                this.togglePaymentAddModal()
              } else {
                sweetErrorAlert("Error", "Failed to add payment");
              }
              this.setState({ isAddTeachersPaymentLoading: false });
            })
            .catch((error)=>{
              console.log(error);
              this.setState({ isAddTeachersPaymentLoading: false });
              sweetErrorAlert("Error", "Failed to add payment");
            });
          });
        }
      }

      handleDatePickerChange = (value) => {
        const dateObject = value ? new Date(value) : undefined;
        const year = dateObject && dateObject.getFullYear();
        const month = dateObject && ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
        const day = dateObject && ("0" + dateObject.getDate()).slice(-2);
    
        const hours = dateObject && dateObject.getHours(); // Get the hours (0-23)
        const minutes = dateObject && dateObject.getMinutes(); // Get the minutes (0-59)
        const seconds = dateObject && dateObject.getSeconds(); // Get the seconds (0-59)
    
        const formattedDateString =
          dateObject && `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        this.setState(() => ({
          hour_date: formattedDateString,
          isModifiedHour: true,
        }));
      };

      handlePaymentDatePickerChange = (value) => {
        const dateObject = value ? new Date(value) : undefined;
        const year = dateObject && dateObject.getFullYear();
        const month = dateObject && ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
        const day = dateObject && ("0" + dateObject.getDate()).slice(-2);
    
        const hours = dateObject && dateObject.getHours(); // Get the hours (0-23)
        const minutes = dateObject && dateObject.getMinutes(); // Get the minutes (0-59)
        const seconds = dateObject && dateObject.getSeconds(); // Get the seconds (0-59)
    
        const formattedDateString =
          dateObject && `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        this.setState(() => ({
          payment_date: formattedDateString,
          isModifiedHour: true,
        }));
      };

      handleChange = (event) => {
        
        const { name, value } = event.target;
        this.setState(() => ({ [name]: value }));
      };

      toggleScreen = (id,state) => {

        if(state === 'hour_capture_view'){
          this.setState((prevState) => ({
            [state]: !prevState[state],
          }),async()=>{
            if(this.state[state]){
              this.setState({selected_teacher_id: id},async()=>{
                await this.getHourCaptureById(id)
              })
              
            }
            else{
              this.getTeachers()
              this.setState({teacher_hours:[],selected_teacher_id:null,teacher_hours_count:0})
            }
          })
        }
        else if(state === 'payment_capture_view'){
          this.setState((prevState) => ({
            [state]: !prevState[state],
          }),async()=>{
            if(this.state[state]){
              this.setState({selected_teacher_id: id},async()=>{
                await this.getTeacherPaymentById(id)
              })
              
            }
            else{
              this.getTeachers()
              this.setState({teacher_payments:[],selected_teacher_id:null,teacher_payments_count:0})
            }
          })
        }

      };

      getHourCaptureById = async(id) =>{

        this.setState({isTeacherHourListLoading:true})
        try {

          const {mid,hours_limit,hours_offset,hours_sort_column,hours_sort_direction} = this.state

          await TeachersPaymentService.getHoursListByTeacherId(id,parseInt(mid),hours_limit,hours_offset,hours_sort_column,hours_sort_direction)
            .then((response)=>{
              if(response.success){
                this.setState({teacher_hours: response?.data?.teacher_hours, teacher_hours_count:response?.data?.teacher_hours_count})
              }
              this.setState({isTeacherHourListLoading:false})
            })
            .catch(()=>{
              console.log("Error getting teacher hours list");
              this.setState({isTeacherHourListLoading:false})

            })
        } 
        catch (error) {
          console.log("Error getting teacher hours list");
          this.setState({isTeacherHourListLoading:false})
        }

      }

      getTeacherPaymentById = async(id) =>{

        this.setState({isTeacherPaymentListLoading:true})

        try {

          const {mid,payment_hours_limit,payment_hours_offset,payment_hours_sort_column,payment_hours_sort_direction} = this.state

          await TeachersPaymentService.getPaymentListByTeacherId(id,parseInt(mid),payment_hours_limit,payment_hours_offset,payment_hours_sort_column,payment_hours_sort_direction)
            .then((response)=>{
              if(response.success){
                this.setState({teacher_payments: response?.data?.teacher_payments, teacher_payments_count:response?.data?.teacher_payments_count})
              }
              this.setState({isTeacherPaymentListLoading:false})
            })
            .catch(()=>{
              console.log("Error getting teacher payment list");
              this.setState({isTeacherPaymentListLoading:false})

            })
        } 
        catch (error) {
          console.log("Error getting teacher payment list");
          this.setState({isTeacherPaymentListLoading:false})
        }

      }

      approve_hour_capture = async(id) =>{
        
          sweetConfirmAlert().then(async() => {
            this.setState({ isTeacherHourListLoading: true })
            
            await TeachersPaymentService.approve_or_reject_hour_capture("approve",id)
              .then((result) => {
              if (result.success) {

                this.setState((prevState) => ({
                  teacher_hours: prevState.teacher_hours.map((hour) =>
                    hour.id === id ? { ...hour, ...result.data.hour } : hour
                  ),
                  isTeacherHourListLoading: false,
                }));

                sweetSuccessAlert(
                  "Success",
                  "Approved successfully",
                  "success"
                );
              } else {
                sweetErrorAlert("Error", "Failed to approve record");
              }
              this.setState({ isTeacherHourListLoading: false });
            })
            .catch((error)=>{
              console.log(error);
              this.setState({ isTeacherHourListLoading: false });
              sweetErrorAlert("Error", "Failed to approve record");
            });
          });
        
      }

      reject_hour_capture = async(id) =>{
        sweetConfirmAlert().then(async() => {
          this.setState({ isTeacherHourListLoading: true })
          
          await TeachersPaymentService.approve_or_reject_hour_capture("reject",id)
            .then((result) => {
            if (result.success) {

              this.setState((prevState) => ({
                teacher_hours: prevState.teacher_hours.map((hour) =>
                  hour.id === id ? { ...hour, ...result.data.hour } : hour
                ),
                isTeacherHourListLoading: false,
              }));

              sweetSuccessAlert(
                "Success",
                "Rejected successfully",
                "success"
              );
            } else {
              sweetErrorAlert("Error", "Failed to reject record");
            }
            this.setState({ isTeacherHourListLoading: false });
          })
          .catch((error)=>{
            console.log(error);
            this.setState({ isTeacherHourListLoading: false });
            sweetErrorAlert("Error", "Failed to reject record");
          });
        });
      }

      handleSearch = (event) => {
        const search_term = event.target.value.trim();
        // const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;
    
        // if (search_term === "" || regex.test(search_term)) {

          this.setState(
            {
              search_term,
              offset: 0,
              currentPage: 0,
              searchError: false,
            },
            () => {
              // Call the debounced version of fetchStudentData
              this.debouncedHandleSearch();
            }
          );
          
        // } else {
        //   this.setState({ search_term, searchError: true });
        // }
      };

      truncateNote(note, length = 8) {
        if (!note) return 'N/A';
        return note.length > length ? note.substring(0, length) + '...' : note;
      }

      toggle_update_screen = (teacher) => {
          
        this.setState((prevState) => ({
          updateTeacherLoading:true,
          showUpdateModal: !prevState.showUpdateModal,
        }),()=>{
          if(this.state.showUpdateModal){
            this.setState({selected_teacher_update:teacher,update_note:teacher?.note,updateTeacherLoading:false})
          }
          else{
            this.setState({selected_teacher_update:null,update_note:'',updateTeacherLoading:false})
          }
        });

      };

      handleUpdateTeacher = async () => {

        sweetConfirmAlert().then(async() => {

          try {

            if(!this.state.update_note || this.state.update_note === ''){
              sweetErrorAlert("Warning","Please edit note before update")
            }
            else{
              this.setState({updateTeacherLoading:true})

              const {update_note,selected_teacher_update} = this.state;

              const new_note = {
                note : update_note
              }

              await TeachersPaymentService.updateTeacher(new_note,selected_teacher_update.id)
                .then((response)=>{
                  
                  if(response.success){
                    this.toggle_update_screen(null)
                    sweetSuccessAlert("Updated","Teacher note updated successfully !!!", "success")
                    this.getTeachers()
                  }
                  else{
                    this.setState({updateTeacherLoading:false})
                    sweetStatusAlert("Failed","Faled to update teacher note",'error')
                  }

                })
                .catch((error)=>{
                  this.setState({updateTeacherLoading:false})
                  sweetStatusAlert("Failed","Faled to update teacher note",'error')
                })

            }
            
          } catch (error) {
            sweetStatusAlert("Failed","Faled to update teacher note",'error')
          }
        })
      }

      delete_teacher_record = async (id) => {

        sweetConfirmAlert().then(async() => {

          try {

            this.setState({isTeacherListLoading:true})

            await TeachersPaymentService.deleteTeacher(id)
              .then((response)=>{

                if(response.success){
                  sweetStatusAlert("Deleted","Teacher deleted successfully",'success')
                  this.getTeachers()
                }
                else{
                  
                  if(response.status === 400){
                    this.setState({isTeacherListLoading:false})
                    sweetStatusAlert("Failed",response.message,'error')
                  }
                  else{
                    this.setState({isTeacherListLoading:false})
                    sweetStatusAlert("Failed","Faled to delete teacher",'error')
                  }
                  
                }
              })
            

          } catch (error) {
            this.setState({isTeacherListLoading:false})
            sweetStatusAlert("Failed","Faled to delete teacher",'error')
          }
        })
      }

      delete_teacher_hour_record = async (id) => {

        sweetConfirmAlert().then(async() => {

          try {

            this.setState({isTeacherHourListLoading:true})

            await TeachersPaymentService.deleteTeacherHour(id)
              .then((response)=>{

                if(response.success){
                  sweetStatusAlert("Deleted","Hour record deleted successfully",'success')
                  this.getHourCaptureById(response.data?.teacher_payment_id)
                }
                else{
                  this.setState({isTeacherHourListLoading:false})
                  sweetStatusAlert("Failed","Faled to delete hour record",'error')
                }
              })
            

          } catch (error) {
            this.setState({isTeacherHourListLoading:false})
            sweetStatusAlert("Failed","Faled to delete hour record",'error')
          }
        })
      }

      delete_teacher_payment_record = async (id) => {

        sweetConfirmAlert().then(async() => {

          try {

            this.setState({isTeacherPaymentListLoading:true})

            await TeachersPaymentService.deleteTeacherPayment(id)
              .then((response)=>{

                if(response.success){
                  sweetStatusAlert("Deleted","Payment record deleted successfully",'success')
                  
                  this.getTeacherPaymentById(response.data?.teacher_payment_id)
                }
                else{
                  this.setState({isTeacherPaymentListLoading:false})
                  sweetStatusAlert("Failed","Failed to delete payment record",'error')
                }
              })

          } catch (error) {
            this.setState({isTeacherPaymentListLoading:false})
            sweetStatusAlert("Failed","Failed to delete payment record",'error')
          }
        })
      }


  render() {

    const {
      privilege_add,
      privilege_edit,
      privilege_delete,
      privilege_view,
      user_list_restriction,
      breadcrumb2,
      flg_list_active,
      teachers,
      teachers_count,
      teachers_list,
      teacher_hours,
      teacher_hours_count,
      teacher_payments,

      currentPage,
      limit,
      offset,
      search_term,

      hours_currentPage,
      hours_limit,
      hours_offset, 

      hour_capture_view,
      payment_capture_view,
      showHourAddModal,
      showPaymentAddModal,
      showUpdateModal,
      isTeacherListLoading,

      hour_description,
      hour_date,
      work_hours,

      payment_description,
      payment_date,
      payment_amount,
      isModifiedPayment,

      fixed_amount,
      hourly_rate,

      payment_currentPage,
      payment_hours_limit,
      payment_hours_offset, 
      payment_hours_sort_column,
      payment_hours_sort_direction,
      teacher_payments_count,

    } = this.state;

    this.validator.purgeFields()

    const path = history.location.pathname;
    const formattedBreadcrumb = breadcrumb2
      ? breadcrumb2.replaceAll(">", " > ")
      : "";

    if(hour_capture_view && !payment_capture_view){

      return(
        <div style={{ height: "90vh", overflow: "auto" }}>
            <ContentWrapper disabled={path === "/manage-search"}>
              <div>
              
                <CardHeader>
                <div className="col-md-12 px-0 d-flex justify-content-end">

                  <div className="col-md-6 px-0 d-flex justify-content-start">
                  <Button
                      className="insert-btn"
                      variant="primary"
                      onClick={() => this.toggleScreen(null,'hour_capture_view')}
                    >
                      Back
                    </Button>
                    &emsp;
                    {!this.state.user_list_restriction  && (
                    <>
                    {this.props.state.path !== "node" && (
                      <p
                        className="py-4"
                        style={{ fontSize: "10.5625px", color: "#00000099" }}
                      >
                        {formattedBreadcrumb
                          ? `${formattedBreadcrumb && formattedBreadcrumb}`
                          : ""}
                      </p>
                    )}
                  </>
                  )}
                  </div>

                 
                    <div className="col-md-6 px-0 d-flex justify-content-end">
                      {privilege_add && this.state.user_list_restriction &&(
                        <Button
                          className="insert-btn"
                          variant="primary"
                          onClick={() => this.toggleHourAddModal(this.showHourAddModal)}
                        >
                          Add Record
                        </Button>
                      )}
                    </div>
                    
                  
                </div>
            </CardHeader>
              <CardBody>
                <Table>
                    <TableHead>
                      <TableRow>

                      <TableCell
                          className="thead">
                          Description
                        </TableCell>

                        <TableCell
                          className="thead">
                          Date
                        </TableCell>

                        <TableCell
                          className="thead">
                           Hours
                        </TableCell>

                        <TableCell
                          className="thead">
                          Status
                        </TableCell>
                        {(privilege_add && privilege_view && !this.state.user_list_restriction) || (privilege_edit && privilege_view && !this.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.state.user_list_restriction) ?(
                        <TableCell
                          className="thead">
                          Actions
                        </TableCell>
                        ):(
                          <></>
                        )}
                      </TableRow>
                    </TableHead>
                {this.state.isTeacherHourListLoading ? (
                  
                  <div className="loading-container">
                    <PageSpinner id="show" text="Loading, Please wait!" />
                    {/* <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner> */}
                  </div>
                ):
                (
                  <TableBody>
                  {teacher_hours?.length > 0 ?(
                    (teacher_hours?.map((hourItem) => (

                      <TableRow key={hourItem?.id}>

                        <TableCell className="tData">
                          {hourItem?.description || 'N/A'}
                        </TableCell>

                        <TableCell className="tData">
                          {TimeZoneHandler.convertTime(new Date(hourItem?.date)) || 'N/A'}
                        </TableCell>

                        <TableCell className="tData">
                          {String(hourItem?.hours) || 'N/A'}
                        </TableCell>

                        <TableCell className="tData">
                        <span
                            className={`label label-lg ${
                              hourItem.status === 1
                                ? "label-light-success"
                                :
                                hourItem.status === 2?
                                "label-light-danger"
                                :
                                "label-light-warning"
                            } label-inline`}
                          >
                            {hourItem.status === 1?'Approved':hourItem.status === 2?'Rejected':'Pending'}
                          </span>
                        </TableCell>

                        <TableCell className="tData">
                          {(privilege_add && privilege_view && !this.state.user_list_restriction) || (privilege_edit && privilege_view && !this.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.state.user_list_restriction) ?(
                          <span>
                            <Button
                              className="btn btn-icon btn-check btn-sm m-1"
                              title="Approve"
                              style={{display:hourItem.status != 1?'':'none', backgroundColor:'#2fab2b', border:'1px solid #2fab2b'}}
                              onClick={() =>
                                this.approve_hour_capture(hourItem?.id)
                              }
                            >
                            <CheckCircleOutlineIcon />
                            </Button>

                            <Button
                              className="btn btn-icon btn-ban btn-sm m-1"
                              title="Reject"
                              style={{display:hourItem.status != 2?'':'none', backgroundColor: '#ee6473', border:'1px solid #ee6473'}}
                              onClick={() =>
                                this.reject_hour_capture(hourItem?.id)
                              }
                            >
                              <CloseIcon />
                            </Button>

                            <Button
                                  className="btn btn-icon btn-danger btn-sm m-1"
                                  title="Delete"
                                  style={{backgroundColor:'#cf162a'}}
                                  onClick={() =>
                                    this.delete_teacher_hour_record(hourItem?.id)
                                  }
                                >
                                  <DeleteIcon/>
                            </Button>

                            </span>
                        ):(hourItem.status === 0 &&
                          <Button
                                  className="btn btn-icon btn-danger btn-sm m-1"
                                  title="Delete"
                                  onClick={() =>
                                    this.delete_teacher_hour_record(hourItem?.id)
                                  }
                                >
                                  <DeleteIcon/>
                            </Button>
                        )}
                        </TableCell>
                        
                      </TableRow>
                    )))
                  ):(
                    <div>
                      No Hour Captures
                    </div>
                  )}
                  </TableBody>
                )}
                </Table>
                <MaterialCustomTablePagination
                  totalCount={teacher_hours_count}
                  currentPage={hours_currentPage}
                  limit={hours_limit}
                  handlePageChange={this.hour_handlePageChange}
                  handleRowsPerPageChange={this.hour_handleRowsPerPageChange}
                  handlePageOffsetChange={this.hour_handlePageOffsetChange}
                  rowsPerPageOptions={[5, 10, 20]}
                  offset={hours_offset}
              />
                </CardBody>
                        
              </div>
            </ContentWrapper>

              <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.showHourAddModal}
                onHide={() => this.toggleHourAddModal(this.showHourAddModal)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Add New Record</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {this.state.isAddTeachersHourRecordLoading ? (
                    <PageSpinner id="show" text="Loading, Please wait!" />
                  ):(

                  <Form>
           
                  <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="4"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Description*</Form.Label>
                    <Form.Control
                      type="text"
                      name="hour_description"
                      placeholder="Enter Description"
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "hour_description",
                      this.state.hour_description,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "The description field is required",
                        },
                      }
                    )}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="5"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Date*</Form.Label>
                    <DatePicker
                      className="py-2 form-control" // Add Bootstrap form control class
                      selected={
                        this.state.hour_date
                          ? new Date(this.state.hour_date)
                          : undefined
                      }
                      name="hour_date"
                      onChange={this.handleDatePickerChange}
                      dateFormat="dd-MM-yyyy h:mm aa" // Set custom date format
                      placeholderText="Date"
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      wrapperClassName="react-datePicker"
                      showTimeSelect={true}
                      showTimeInput
                    />
                    {this.validator.message(
                      "hour_date",
                      this.state.hour_date,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "The date field is required",
                        },
                      }
                    )}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Hours</Form.Label>
                    <Form.Control
                      type="text"
                      name="work_hours"
                      placeholder="Enter Hours"
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "work_hours",
                      this.state.work_hours,
                      "required|greaterThanZero|numeric",
                      {
                        className: "text-danger",
                        messages: {
                          required: "The work hours required",
                          numeric:"The work hours must be a number"
                        },
                      }
                    )}
                    
                  </Form.Group>
                </Row>
                    
                  </Form>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button disabled={this.state.isAddTeachersHourRecordLoading } style={addBtnStyle} onClick={this.handleAddNewHoursRecord}>
                    Save changes
                  </Button>
                  <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    disabled={this.state.isAddTeachersHourRecordLoading }
                    onClick={() => this.toggleHourAddModal(this.showHourAddModal)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
        </div>
      )
    }
    else if(payment_capture_view && !hour_capture_view){

      return(
        <div style={{ height: "90vh", overflow: "auto" }}>
            <ContentWrapper disabled={path === "/manage-search"}>
              <div>
              <CardHeader>
                <div className="col-md-12 px-0 d-flex justify-content-end">

                  <div className="col-md-6 px-0 d-flex justify-content-start">
                  <Button
                      className="insert-btn"
                      variant="primary"
                      onClick={() => this.toggleScreen(null,'payment_capture_view')}
                    >
                      Back
                    </Button>
                  </div>

                  {!this.state.user_list_restriction  && (
                    <>
                    {this.props.state.path !== "node" && (
                      <p
                        className="py-4"
                        style={{ fontSize: "10.5625px", color: "#00000099" }}
                      >
                        {formattedBreadcrumb
                          ? `${formattedBreadcrumb && formattedBreadcrumb}`
                          : ""}
                      </p>
                    )}
                  </>
                  )}
                    <div className="col-md-6 px-0 d-flex justify-content-end">
                      {(privilege_edit && privilege_view && !this.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.state.user_list_restriction) ?(
                        <Button
                          className="insert-btn"
                          variant="primary"
                          onClick={() => this.togglePaymentAddModal(this.showPaymentAddModal)}
                        >
                          Add Payment
                        </Button>
                      ):(
                        <></>
                      )}
                    </div>
                   
                </div>
            </CardHeader>
              <CardBody>
                <Table>
                    <TableHead>
                      <TableRow>

                      <TableCell
                          className="thead">
                          Description
                        </TableCell>

                        <TableCell
                          className="thead">
                          Date
                        </TableCell>

                        <TableCell
                          className="thead">
                           Amount
                        </TableCell>
                        {(privilege_edit && privilege_view && !this.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.state.user_list_restriction) ?(

                        <TableCell
                          className="thead">
                           Actions
                        </TableCell>
                        ):(
                          <></>
                        )}
                      </TableRow>
                    </TableHead>
                {this.state.isTeacherPaymentListLoading ? (
                  
                  <div className="loading-container">
                     <PageSpinner id="show" text="Loading, Please wait!" />
                  </div>
                ):
                (
                  <TableBody>
                  {teacher_payments?.length > 0 ?(
                    (teacher_payments?.map((payment) => (

                      <TableRow key={payment?.id}>

                        <TableCell className="tData">
                          {payment?.description || 'N/A'}
                        </TableCell>

                        <TableCell className="tData">
                          {TimeZoneHandler.convertTime(new Date(payment?.date)) || 'N/A'}
                        </TableCell>

                        <TableCell className="tData">
                          {'LKR'+' '+String(payment?.amount) || 'N/A'}
                        </TableCell>
                        {(privilege_edit && privilege_view && !this.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.state.user_list_restriction) ?(
                        <TableCell className="tData">
                          <Button
                            className="btn btn-icon btn-danger btn-sm m-1"
                            title="Delete"
                            onClick={() =>
                              this.delete_teacher_payment_record(payment?.id)
                            }
                          >
                            <DeleteIcon/>
                          </Button>
                        </TableCell>
                        ):(
                          <></>
                        )}
                        
                        
                      </TableRow>
                    )))
                  ):(
                    <div>
                      No Payments
                    </div>
                  )}
                  </TableBody>
                )}
                </Table>
                <MaterialCustomTablePagination
                  totalCount={teacher_payments_count}
                  currentPage={payment_currentPage}
                  limit={payment_hours_limit}
                  handlePageChange={this.payment_handlePageChange}
                  handleRowsPerPageChange={this.payment_handleRowsPerPageChange}
                  handlePageOffsetChange={this.payment_handlePageOffsetChange}
                  rowsPerPageOptions={[5, 10, 20]}
                  offset={payment_hours_offset}
              />
                </CardBody>
              </div>
            </ContentWrapper>

            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.showPaymentAddModal}
                onHide={() => this.togglePaymentAddModal(this.showPaymentAddModal)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Add New Payment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {this.state.isAddTeachersPaymentLoading ? (
                    <PageSpinner id="show" text="Loading, Please wait!" />
                  ):(
                  <Form>
                    
                  <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="4"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Description*</Form.Label>
                    <Form.Control
                      type="text"
                      name="payment_description"
                      placeholder="Enter Description"
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "payment_description",
                      this.state.payment_description,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "The description field is required",
                        },
                      }
                    )}
                  </Form.Group>
                
                  <Form.Group
                    as={Col}
                    md="5"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Date*</Form.Label>
                    <DatePicker
                      className="py-2 form-control" // Add Bootstrap form control class
                      selected={
                        this.state.payment_date
                          ? new Date(this.state.payment_date)
                          : undefined
                      }
                      name="payment_date"
                      onChange={this.handlePaymentDatePickerChange}
                      dateFormat="dd-MM-yyyy h:mm aa" // Set custom date format
                      placeholderText="Date"
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      wrapperClassName="react-datePicker"
                      showTimeSelect={true}
                      showTimeInput
                    />
                    {this.validator.message(
                      "payment_date",
                      this.state.payment_date,
                      "required",
                      {
                        className: "text-danger",
                        messages: {
                          required: "The date field is required",
                        },
                      }
                    )}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md="3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="payment_amount"
                      placeholder="Enter AMount"
                      min={1}
                      onChange={this.handleChange}
                    />
                    {this.validator.message(
                      "payment_amount",
                      this.state.payment_amount,
                      "required|greaterThanZero|numeric",
                      {
                        className: "text-danger",
                        messages: {
                          required: "The amount required",
                          greaterThanZero: "The amount must greater than 0",
                          numeric: "The amount must be a number"
                        },
                      }
                    )}
                  </Form.Group>
                </Row>
                    
                  </Form>
                )}
                </Modal.Body>
                <Modal.Footer>
                  <Button style={addBtnStyle} onClick={this.handleAddTeacherNewPayment}>
                    Save changes
                  </Button>
                  <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() => this.togglePaymentAddModal(this.showPaymentAddModal)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
            </Modal>
        </div>
      )
    }

      return (
        <>

        <div style={{ height: "90vh", overflow: "auto" }}>
            <ContentWrapper disabled={path === "/manage-search"}>
              <div>

                {!user_list_restriction && (
                    <div className="col-md-12 pl-6 pt-5 d-flex justify-content-start">
                      <Tooltip title={privilegeSetup} placement="right-end" arrow>
                          <HelpIcon/>
                      </Tooltip>
                      </div>
                      )}

                {(privilege_add === 1 || this.props.state.path !== "node") && (
                  <CardHeader>
                    <div className="col-md-12 px-0 d-flex justify-content-end">

                    

                      {this.props.state.path !== "node" && (
                        <p
                          className="py-4"
                          style={{ fontSize: "10.5625px", color: "#00000099" }}
                        >
                          {formattedBreadcrumb
                            ? `${formattedBreadcrumb && formattedBreadcrumb}`
                            : ""}
                        </p>
                      )}

                      <div className="col-md-6 px-0 d-flex justify-content-end">
                        {(privilege_add && privilege_view && !this.props.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.props.state.user_list_restriction) ?(
                          <Button
                            className="insert-btn"
                            variant="primary"
                            onClick={() => this.toggleModal(this.showAddModal)}
                          >
                            Add Teacher
                          </Button>
                        ):(
                          <></>
                        )}
                      </div>
                    </div>
                    <Form.Group
                          controlId="exampleForm.ControlInput1"
                          className="col-md-8 mb-2 px-0"
                        >
                          <Form.Control
                            type="text"
                            placeholder="Search"
                            onChange={this.handleSearch}
                            isInvalid={this.state.searchError}
                            className="search-bar"
                          />
                          {this.state.searchError && (
                            <Form.Control.Feedback type="invalid">
                              Invalid input
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                  </CardHeader>
                )}
                <CardBody>
                  {isTeacherListLoading ? (
                    // <PageSpinner id="show" text="Loading, Please wait!" />
                    <div className="loading-container">
                      <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                      </Spinner>
                    </div>
                  ):
                    teachers?.length > 0 ? (
                      <div>
                        
                        <Table>
                          <TableHead>
                            <TableRow>

                            <TableCell
                                className="thead">
                                User Code
                              </TableCell>

                              <TableCell
                                className="thead">
                                Name
                              </TableCell>

                              <TableCell
                                className="thead">
                                Note
                              </TableCell>

                              <TableCell
                                className="thead">
                                Fixed Amount
                              </TableCell>

                              <TableCell
                                className="thead">
                                Hourly Rate
                              </TableCell>

                              <TableCell
                                className="thead">
                                Total Payable
                              </TableCell>

                              <TableCell
                                className="thead">
                                Due Amount
                              </TableCell>

                              <TableCell
                                className="thead">
                                Actions
                              </TableCell>

                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {teachers?.map((teacher) => (

                              <TableRow key={teacher?.id}>

                                <TableCell className="tData">
                                  {teacher?.user_code || 'N/A'}
                                </TableCell>

                                <TableCell className="tData">
                                  {teacher?.first_name + " " + teacher?.last_name || 'N/A'}
                                </TableCell>

                                <TableCell className="tData">
                                  <Tooltip title={teacher?.note || 'N/A'} placement="right-end" arrow>
                                  <span>
                                    {this.truncateNote(teacher?.note || 'N/A')}
                                  </span>
                                  </Tooltip>
                                </TableCell>

                                <TableCell className="tData">
                                  {'LKR ' + String(teacher?.fixed_amount) || 'N/A'}
                                </TableCell>

                                <TableCell className="tData">
                                  {'LKR ' + String(teacher?.hourly_rate) || 'N/A'}
                                </TableCell>

                                <TableCell className="tData">
                                  {'LKR ' + String(teacher?.total_payable) || 'N/A'}
                                </TableCell>
                                
                                <TableCell className="tData">
                                  {'LKR ' + String(teacher?.due_amount) || 'N/A'}
                                </TableCell>

                                <TableCell className="tData">
                                <Button
                                    className="btn btn-icon btn-primary btn-sm m-1 flaticon-time"
                                    title="Hours"
                                    onClick={() =>
                                      this.toggleScreen(teacher?.id,'hour_capture_view')
                                    }
                                  />
                                
                                <Button
                                    className="btn btn-icon btn-info btn-sm m-1"
                                    title="Payments"
                                    onClick={() =>
                                      this.toggleScreen(teacher?.id,'payment_capture_view')
                                    }
                                  >
                                    <Payment/>
                                  </Button>
                                  {(privilege_add && privilege_view && !this.props.state.user_list_restriction) || (privilege_add && privilege_view && privilege_edit && privilege_view && !this.props.state.user_list_restriction)?(
                                  <>
                                  <Button
                                    className="btn btn-icon btn-warning btn-sm m-1"
                                    title="Update"
                                    onClick={() =>
                                      this.toggle_update_screen(teacher)
                                    }
                                  >
                                    <DriveFileRenameOutlineIcon/>
                                  </Button>

                                  <Button
                                  className="btn btn-icon btn-danger btn-sm m-1"
                                  title="Delete"
                                  onClick={() =>
                                    this.delete_teacher_record(teacher?.id)
                                  }
                                  >
                                  <DeleteIcon/>
                                  </Button>
                                  </>
                                  ):(
                                    <></>
                                  )}
                                  
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>

                          </Table>
                          <MaterialCustomTablePagination
                              totalCount={teachers_count}
                              currentPage={currentPage}
                              limit={limit}
                              handlePageChange={this.handlePageChange}
                              handleRowsPerPageChange={this.handleRowsPerPageChange}
                              handlePageOffsetChange={this.handlePageOffsetChange}
                              rowsPerPageOptions={[5, 10, 20]}
                              offset={offset}
                          />
                          </div>
                  ):(
                    <div className="text-center mb-5 mt-10">
                      <Table>
                          <TableHead>
                            <TableRow>

                              <TableCell
                                className="thead">
                                User Code
                              </TableCell>

                              <TableCell
                                className="thead">
                                Name
                              </TableCell>

                              <TableCell
                                className="thead">
                                Note
                              </TableCell>

                              <TableCell
                                className="thead">
                                Fixed Amount
                              </TableCell>

                              <TableCell
                                className="thead">
                                Hourly Rate
                              </TableCell>

                              <TableCell
                                className="thead">
                                Total Payable
                              </TableCell>

                              <TableCell
                                className="thead">
                                Due Amount
                              </TableCell>

                            </TableRow>
                          </TableHead>

                          <TableBody style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                            <label>No Teachers Available!</label>
                          </TableBody>

                          </Table>

                    </div>
                  )}
                </CardBody>
                </div>
            </ContentWrapper>


                <Modal
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  show={this.state.showAddModal}
                  onHide={() => this.toggleModal(this.showAddModal)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Teacher</Modal.Title>
                  </Modal.Header>
                  {this.state.addTeacherLoading?
                    <PageSpinner id="show" text="Loading, Please wait!" />
                  :
                  <Modal.Body>
                    <Form>
                      <Row className="my-5">
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="exampleForm.ControlInput2"
                        >
                        <Form.Label>Teachers</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="selected_teacher"
                          onChange={this.handleChange}
                          value={this.state.selected_teacher}
                          disabled={this.state.dropdown_loading}
                        >
                          {this.state.dropdown_loading?
                            <option value="">Loading...</option>
                          :
                          <option value="">Select</option>
                          }
                          
                          {teachers_list?.map((teacher) => (
                            <option key={teacher?.user_id} value={teacher?.user_id}>
                              {`[${teacher?.user_code}] ${teacher?.first_name} ${teacher?.last_name}`}
                            </option>
                          ))}
                        </Form.Select>
                        </Form.Group>
                      </Row>
                      {this.state.selected_teacher &&
                      <Row className="my-5" >

                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="exampleForm.ControlInput2"
                        >

                          <Form.Label>Fixed Amount</Form.Label>
                          <Form.Control
                            type="number"
                            name="fixed_amount"
                            placeholder="Enter Fixed Amount"
                            onChange={this.handleChange}
                            value={this.state.fixed_amount}
                          />
                          {this.validator.message(
                            "fixed_amount",
                            this.state.fixed_amount,
                            `positiveOrEmpty|atLeastOneFieldRequired:${this.state.hourly_rate}`,
                            {
                              className: "text-danger",
                            }
                          )}
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="exampleForm.ControlInput2"
                        >

                          <Form.Label>Hourly Rate</Form.Label>
                          <Form.Control
                            type="number"
                            name="hourly_rate"
                            placeholder="Enter Hourly Rate"
                            onChange={this.handleChange}
                            value={this.state.hourly_rate}
                          />
                          {this.validator.message(
                            "hourly_rate",
                            this.state.hourly_rate,
                            `positiveOrEmpty|atLeastOneFieldRequired:${this.state.fixed_amount}`,
                            {
                              className: "text-danger",
                            }
                          )}
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="exampleForm.ControlInput2"
                        >

                          <Form.Label>Note</Form.Label>
                          <Form.Control
                            type="text"
                            name="note"
                            placeholder="Enter Note"
                            onChange={this.handleChange}
                            value={this.state.note}
                          />
                          {this.validator.message(
                            "note",
                            this.state.note,
                            'required',
                            {
                              className: "text-danger",
                              messages: {
                                required: "The note field is required",
                              },
                            }
                          )}
                        </Form.Group>

                      </Row>
                      }
                    </Form>
                  </Modal.Body>
                  }
                  <Modal.Footer>
                    <Button disabled={this.state.addTeacherLoading || !this.state.selected_teacher} style={addBtnStyle} onClick={this.handleAddTeacherSubmit}>
                      Save changes
                    </Button>
                    <Button
                      id="modal-close-button"
                      style={closeBtnStyle}
                      disabled={this.state.addTeacherLoading}
                      onClick={() => this.toggleModal(this.showAddModal)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>


                <Modal
                  size="md"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  show={this.state.showUpdateModal}
                  onHide={() => this.toggle_update_screen(null)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Update Teacher</Modal.Title>
                  </Modal.Header>
                  {this.state.updateTeacherLoading ?
                    <PageSpinner id="show" text="Loading, Please wait!" />
                  :
                  <Modal.Body>
                    <Form>
                      <Row className="my-5" >

                        <Form.Group
                          as={Col}
                          md="12"
                          controlId="exampleForm.ControlInput2"
                        >

                          <Form.Label>Note</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}                          
                            name="update_note"
                            placeholder="Enter Note"
                            onChange={this.handleChange}
                            value={this.state.update_note}
                          />
                        </Form.Group>

                      </Row>
                    </Form>
                  </Modal.Body>
                  }

                  <Modal.Footer>
                    <Button disabled={this.state.updateTeacherLoading || !this.state.selected_teacher_update} style={addBtnStyle} onClick={this.handleUpdateTeacher}>
                      Save changes
                    </Button>
                    <Button
                      id="modal-close-button"
                      style={closeBtnStyle}
                      disabled={this.state.updateTeacherLoading}
                      onClick={() => this.toggle_update_screen(null)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
        </div>
        </>
      )
  }
}
